export const CHATTING_ANIMATION_LENGTH = 875;
